import { isHotkey as isHotkeyLib } from 'is-hotkey'
import type { HotKeyOptions, KeyboardEventLike } from 'is-hotkey'

/** @note we wrap this to get around some type issues */
export const isHotkey = (hotkey: string | readonly string[], options?: HotKeyOptions | undefined) =>
  isHotkeyLib(hotkey, options) as (ev: KeyboardEventLike) => boolean
